import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export const UPDATE_MAIN_CONFIGURATIONS = "updateMAINCONFIGURATIONSConfigs";
export const SAVE_MAIN_CONFIGURATIONS = "saveMAINCONFIGURATIONSConfigs";

export const SET_MAIN_CONFIGURATIONS = "setMAINCONFIGURATIONSConfigs";
export const SET_SELECTED_WAREHOUSE_INDEX =
  "setMAINCONFIGURATIONSSelectedWarehouseIndex";

const state = {
  mainConfigurations: {},
  selectedWarehouseIndex: null,
};

const getters = {
  getMAINConfigurations(state) {
    return state.mainConfigurations;
  },
  getMAINConfigurationsApplyRulesTypes(state) {
    return state.mainConfigurations.apply_rule_types || [];
  },
  getMAINConfigurationsDetails(state) {
    return state.mainConfigurations.configurations || {};
  },
  getMAINConfigurationsClients(state) {
    return state.mainConfigurations.clients || [];
  },
  getMAINConfigurationsDamageLocations(state) {
    return state.mainConfigurations.damage_locations || [];
  },
  getMAINConfigurationsLocations(state) {
    return state.mainConfigurations.locations || [];
  },
  getMAINConfigurationsTransferLocations(state) {
    return state.mainConfigurations.transfer_locations || [];
  },
  getMAINConfigurationsAsnTypes(state) {
    return state.mainConfigurations.asn_types || [];
  },
  getSelectedWarehouseIndex(state) {
    return state.selectedWarehouseIndex;
  },
  getMAINConfigurationsProcessedItemsHandlingOptions(state) {
    return state.mainConfigurations.processed_items_handling_options || [];
  },
  getMAINConfigurationsRefundTriggerStatus(state) {
    return state.mainConfigurations.refund_trigger_status || [];
  }
};

const actions = {
  async [UPDATE_MAIN_CONFIGURATIONS](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      ApiService.setHeader();
      const { data } = await ApiService.post(
        "/warehouse_management/main_configuration/create",
        payload
      );

      context.commit(SET_MAIN_CONFIGURATIONS, data);

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1000);

      return data;
    } catch (error) {
      console.error("Error updating main configurations:", error);
      throw error;
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
  async [SAVE_MAIN_CONFIGURATIONS](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      ApiService.setHeader();
      const { data } = await ApiService.post(
        "/warehouse_management/main_configuration/store",
        payload
      );

      // Optionally refresh the configurations after save
      // You can uncomment this if the server returns updated data
      // context.commit(SET_MAIN_CONFIGURATIONS, data);

      return data;
    } catch (error) {
      console.error("Error saving main configurations:", error);
      throw error;
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
};

const mutations = {
  [SET_MAIN_CONFIGURATIONS](state, data) {
    state.mainConfigurations = data;
  },
  [SET_SELECTED_WAREHOUSE_INDEX](state, index) {
    state.selectedWarehouseIndex = index;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
